mutation addMarketingPlanSlot($input: AddMarketingPlanSlotInput!) {
  slot: addMarketingPlanSlot(input: $input) {
    id
    platform
    topicId
    topicName
    scheduledLocal {
      date
      time
    }
    textStatus
  }
}
